// extracted by mini-css-extract-plugin
export default {"container":"style_container__6PmGD","child":"style_child__PyUXe"};